import type { ProfileUpdate } from "components/users/types";

import type { ChangeFields } from "../changes";

type Upload = { storedName?: string; title?: string; name?: string };

/** Everything the Profile tab of user settings saves. */
export const userProfileFields: ChangeFields<
  { uploads?: Upload[] } & Pick<
    ProfileUpdate,
    | "firstName"
    | "lastName"
    | "avatar"
    | "coverImage"
    | "video"
    | "tagline"
    | "overview"
    | "linkedin"
    | "github"
    | "instagram"
    | "website"
    | "twitter"
    | "facebook"
  >
> = {
  firstName: { kind: "text", label: "changes.user.firstName" },
  lastName: { kind: "text", label: "changes.user.lastName" },
  avatar: { kind: "file", label: "changes.user.avatar" },
  coverImage: { kind: "file", label: "changes.user.coverImage" },
  video: { kind: "file", label: "changes.user.video" },
  tagline: { kind: "text", label: "changes.user.tagline" },
  overview: { kind: "text", label: "changes.user.overview" },
  linkedin: { kind: "text", label: "changes.user.linkedin" },
  github: { kind: "text", label: "changes.user.github" },
  instagram: { kind: "text", label: "changes.user.instagram" },
  website: { kind: "text", label: "changes.user.website" },
  twitter: { kind: "text", label: "changes.user.twitter" },
  facebook: { kind: "text", label: "changes.user.facebook" },
  uploads: {
    kind: "list",
    label: "changes.user.uploads",
    item: "changes.user.upload",
    key: (upload) => upload.storedName,
    name: (upload) => upload.title || upload.name,
  },
};
